import { Link } from "react-router-dom";
import { FiEye, FiPlus} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export const ReportingCard = 
({ icon, title, description, link, accentColor }) => {
  const navigate = useNavigate()
  return (
    <div
      className="group relative flex flex-col h-full rounded-lg border border-border bg-card overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
      style={{ animationDelay: "0ms" }}
    >
      {/* Accent top bar */}
      <div className={`h-1.5 w-full ${accentColor}`} />

      <div className="flex flex-col flex-1 p-5 gap-3">
        {/* Icon + Title */}
        <div className="flex items-center gap-3">
          <div
            className={`flex items-center justify-center w-10 h-10 rounded-lg ${accentColor} text-primary-foreground text-lg shrink-0`}
          >
            {icon}
          </div>
          <h3 className="font-display font-semibold text-base text-card-foreground leading-tight">
            {title}
          </h3>
        </div>

        {/* Description */}
        <p className="text-sm text-muted-foreground leading-relaxed flex-1">
          {description}
        </p>

        {/* Action buttons */}
        <div className="flex gap-2 pt-1">
          <button
            className="flex items-center justify-center gap-1.5 h-9 px-3 text-sm rounded-md border border-input bg-background hover:bg-accent hover:text-accent-foreground flex-1"
            onClick={() => navigate(link, { state: { bypassModal: false } })}
          >
              <FiEye className="w-3.5 h-3.5" />
              View Entries
          </button>
          <button
          className="flex items-center justify-center gap-1.5 h-9 px-3 text-sm rounded-md bg-primary text-primary-foreground hover:bg-primary/90 flex-1"
          onClick={() => navigate(link, { state: { bypassModal: true } })}
        >
              <FiPlus className="w-3.5 h-3.5" />
          Add Entry
        </button>
        </div>
      </div>
    </div>
  );
};

export default ReportingCard;
